module.exports = __webpack_public_path__ + "img/icon_wy09.1c445260.png";